module.exports = __webpack_public_path__ + "static/img/no-coupon-icon.ff2598ec.png";